export default "__VITE_ASSET__0uJ6LMBJ__"